/*
 * vuetify.js
 *
 * Description:
 *
 * This file is part of: "http://apps.sundair.com/", "SunCrew2"
 * Copyright 2019 Sundair GmbH
 * Contact: http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import i18n from '@/i18n';
import '@/sass/overrides.sass';

import AirplaneSeatIcon from '../assets/customIcons/AirplaneSeatIcon.vue';
import AirplaneSeatCrossedIcon from '../assets/customIcons/AirplaneSeatCrossedIcon.vue';
import LogoutIcon from '../assets/customIcons/LogoutIcon.vue';
import User2Icon from '../assets/customIcons/User2Icon.vue';

Vue.use(Vuetify);

const theme = {
    primary: '#AB3B7A',
    secondary: '#9C27b0',
    accent: '#9C27b0',
    info: '#00CAE3'
};


export default new Vuetify({
    lang: {
        t: (key, ...params) => i18n.t(key, params)
    },
    theme: {
        themes: {
            dark: theme,
            light: theme
        }
    },
    icons: {
        values: {
            airplaneSeat: {
                component: AirplaneSeatIcon
            },
            airplaneSeatCrossed: {
                component: AirplaneSeatCrossedIcon
            },
            logout: {
                component: LogoutIcon
            },
            user2: {
                component: User2Icon
            }
        }
      }
});
